module.exports = {
      id: "close-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }